import React, { useState } from "react";
import {
  Box,
  Button,
  FormControl,
  MenuItem,
  Select,
  Stack,
  Typography,
} from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers";
import MaterialModal from "../../../../app/material-modal";

export function AssignLicenseModal({
  open,
  handleClose,
  invoicesData,
  setInviteList,
  inviteList,
  selectedInviteUserData
}) {
  const [invoiceNo, setInvoiceNo] = useState("");
  const [product, setProduct] = useState({});

  const handleSubmit = (e) => {
    e.preventDefault();

    const newInviteList = {
      ...inviteList,
      data: [...inviteList?.data],
    };

    selectedInviteUserData.forEach((user) => {
      const idx = newInviteList.data.findIndex(item => item._id === user._id);
      if (idx !== -1) {
        newInviteList.data[idx] = {
          ...newInviteList.data[idx],
          productID: product?.product?.productID,
        };
      }
    });

    const updatedSeats = newInviteList.selectedInvoiceSeats;

    if (updatedSeats[product?.product?.productID]) {
        if (updatedSeats[product?.product?.productID][product?.invoiceKey]) {
          updatedSeats[product?.product?.productID][product?.invoiceKey] += selectedInviteUserData?.length;
        } else {
          updatedSeats[product?.product?.productID][product?.invoiceKey] = selectedInviteUserData?.length;
        }
    } else {
        updatedSeats[product?.product?.productID] = {
          [product?.invoiceKey]: selectedInviteUserData?.length
        };
    }

    setInviteList(newInviteList);
    handleClose();
  };

  const availableSeats  = product?.product ? product?.product?.quantity - product?.product?.usedQuantity : 0;
  const isAssignable = availableSeats - (
    (selectedInviteUserData?.length || 0) +
    (inviteList?.selectedInvoiceSeats?.[product?.product?.productID]?.[product?.invoiceKey] || 0)
  );

  return (
    <MaterialModal
      open={open}
      handleDialogClose={handleClose}
      styleOverrides={{
        container: {
          "& .MuiDialog-paper": {
            width: "100%",
            minHeight: "400px",
            maxWidth: "500px",
            ".MuiDialogContent-root": {
              overflow: "auto",
            },
          },
        },
      }}
      title="Assign License"
    >
      <form onSubmit={handleSubmit}>
        <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
          {/* Top Info */}

          <Stack direction="row" gap={3}>
            <Typography variant="body1" sx={{ flexBasis: "40%" }}>
              Total seats
            </Typography>
            <Typography variant="body1" fontWeight={700}>
              {product?.product?.quantity}
            </Typography>
          </Stack>

          <Stack direction="row" gap={3}>
            <Typography variant="body1" sx={{ flexBasis: "40%" }}>
              Seats Used
            </Typography>
            <Typography variant="body1" sx={{ mb: 1, fontWeight: 700 }}>
              {product?.product?.usedQuantity}
            </Typography>
          </Stack>

          <Stack direction="row" gap={3}>
            <Typography variant="body1" sx={{ flexBasis: "40%" }}>
              Product
            </Typography>
            <Typography variant="body1" sx={{ mb: 1, fontWeight: 700 }}>
              {product?.product?.productName}
            </Typography>
          </Stack>

          {/* Select Invoice */}
          <Stack direction="column">
            <Typography variant="body1">Invoice List</Typography>
            <Typography variant="caption" sx={{ mt: 1 }}>
              Select the invoices you want to use
            </Typography>
          </Stack>

          <Stack direction="row" alignItems="center">
            <Box sx={{ flexBasis: "40%" }}>
              <Typography sx={{ fontWeight: "bold" }}> Product Type</Typography>
            </Box>
            <Box sx={{ flexBasis: "60%" }}>
              <FormControl size="small" fullWidth>
                <Select
                  name="product"
                  value={invoiceNo || ""}
                  onChange={(event) => {
                    setInvoiceNo(event.target.value.name);
                    setProduct(event.target.value);
                  }}
                  displayEmpty
                  required
                  renderValue={(val) => {
                    return val ? <em>{val}</em> : <em>Select Invoice</em>;
                  }}
                >
                  <MenuItem value="" disabled>
                    Select Invoice
                  </MenuItem>
                  {invoicesData?.map((invoice, idx) => (
                    <MenuItem key={idx} value={invoice}>
                      {invoice?.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Box>
          </Stack>

          {/* Footer */}
          <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 1 }}>
            <Button variant="outlined" onClick={handleClose}>
              Cancel
            </Button>
            <Button
              variant="contained"
              type="submit"
              disabled={ isAssignable<=0 }
            >
              Assign
            </Button>
          </Box>
        </Box>
      </form>
    </MaterialModal>
  );
}
